import useMyProfileStore from "@/hooks/useMyProfileStore";
import { Button, Card, Tag } from "antd";
import pluralize from "pluralize";
import { useMemo } from "react";
import { HiPencil } from "react-icons/hi";

const ProfileInterestWidget = () => {
  const { userView, setState } = useMyProfileStore();

  const sortedTags = useMemo(() => {
    if (userView?.interests) {
      const sortedInterests = [...userView.interests];
      sortedInterests.sort((a: any, b: any) => {
        // Compare by category
        if (a?.category < b?.category) return -1;
        if (a?.category > b?.category) return 1;

        // If categories are the same, compare by name
        return a?.name?.localeCompare(b?.name);
      });

      return sortedInterests;
    }

    return userView?.interests;
  }, [userView?.interests]);

  const groupedData = useMemo(() => {
    return sortedTags?.reduce((result: any, item: any) => {
      const { category } = item;

      // Check if category is already in the result
      if (result[category]) {
        result[category].items.push(item);
      } else {
        // If not, create a new category with the item as the first element
        result[category] = { category: pluralize(category, 10), items: [item] };
      }

      return result || {};
    }, {});
  }, [userView?.interests]);

  return (
    <Card
      title={
        <div className="flex w-full items-center justify-between">
          <h3 className="font-bold text-lg text-white ">
            My Interests
          </h3>
          <Button
            type="text"
            icon={<HiPencil />}
            onClick={() => setState({ isEditInterestModalOpen: true })}
          />
        </div>
      }
    >
      {groupedData && Object.values(groupedData)?.length > 0 ? (
        <div className="flex flex-col gap-4">
          {Object.values(groupedData).map((parentItem: any, i: number) => (
            <div key={i}>
              <p className="font-semibold mb-[10px]">{parentItem?.category}</p>

              <div className="flex flex-wrap gap-[10px]">
                {parentItem?.items?.map((item: any, idx: number) => (
                  <Tag
                    color="#fff"
                    key={`Interests-tag-${idx}`}
                    style={{
                      margin: 0,
                      color: "#000",
                    }}
                  >
                    {item?.name}
                  </Tag>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <>Earn points by highlighting your interests here!</>
      )}
    </Card>
  );
};

export default ProfileInterestWidget;
